import styled from 'styled-components';

export const StyledHeadline = styled.span`
  div {
    color: var(--text-color-headline-invert);
    letter-spacing: 1px;
  }
`;
